import Vue from 'vue'
import App from './App.vue'
import './utils/rem'
import './utils/normalize.css'
import jsencrypt from 'jsencrypt'
import api from './request/api/index'
import { Popup,Button,Toast,Image,Row, Col } from 'vant'
Vue.use(Row).use(Col);
Vue.use(Popup);
Vue.use(Button);
Vue.use(Toast);
Vue.use(Image);

Vue.config.productionTip = false
Vue.prototype.$jsencrypt=new jsencrypt();
Vue.prototype.$api=api;
new Vue({
  render: h => h(App),
}).$mount('#app')
